import { createApi } from '@reduxjs/toolkit/query/react';

import { PaginatedResponse } from '../common/dto/common.dto';
import { ExceptionFilterDto, ExceptionViewDto } from '../common/dto/exception-reports.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_REPORT_SERVICE;
const TAG_TYPE = 'ExceptionReport';
const TAG_TYPE_SINGLE = 'ExceptionReport-Single';

export const exceptionReportApi = createApi({
  reducerPath: 'exceptionReportApi',
  baseQuery: customFetchBase(`${API_URI}/api/exception-report`),
  tagTypes: [TAG_TYPE, TAG_TYPE_SINGLE],
  endpoints: (builder) => ({
    searchExceptionReports: builder.mutation<PaginatedResponse<ExceptionViewDto>, Partial<ExceptionFilterDto>>({
      query(body) {
        return {
          url: ``,
          method: 'PATCH',
          body,
        };
      },
    }),
    getException: builder.query<ExceptionViewDto, string>({
      query: (id: string) => {
        return `${id}`;
      },
      providesTags: [TAG_TYPE_SINGLE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useSearchExceptionReportsMutation, useGetExceptionQuery, useLazyGetExceptionQuery } = exceptionReportApi;
